import type { FFmpeg } from '@ffmpeg/ffmpeg'

type WindowWithFFmpeg = typeof window & {
  ffmpeg: FFmpeg
}

export const getFFmpeg = async () => {
  const w = window as WindowWithFFmpeg
  w.ffmpeg = w.ffmpeg || (await loadFFmpeg())
  return w.ffmpeg
}

const loadFFmpeg = async () => {
  const { FFmpeg } = await import('@ffmpeg/ffmpeg')
  const ffmpeg = new FFmpeg()
  await ffmpeg.load({
    coreURL: `${window.location.origin}/scripts/ffmpeg-core.js`,
    wasmURL: `${window.location.origin}/scripts/ffmpeg-core.wasm`,
    workerURL: `${window.location.origin}/scripts/ffmpeg-core.worker.js`,
  })
  return ffmpeg
}
